import PageTitle from '../components/CommonComps/Titles/PageTitle';
import ReminderMutationModals from '../components/SentRemindersComps/ReminderMutationModals';
import ShowAllSentReminders from '../components/SentRemindersComps/ShowAllSentReminders';
import MutationModalProvider from '../contexts/MutationModalProvider';

const SentReminders = () => {
  // rendering sent notifications page component here
  return (
    <>
      <PageTitle title='Sent Reminders' />

      <MutationModalProvider>
        <ShowAllSentReminders />
        <ReminderMutationModals />
      </MutationModalProvider>
    </>
  );
};

export default SentReminders;
